import React from 'react';

const Volunteer = () => {
  return <h1 className="text-center">VOLUNTEER PAGE</h1>;
};

export default Volunteer;
